import React from "react";
import { colors } from '../../../theme/colors';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from "@mui/material";

import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CloseIcon from "@mui/icons-material/Close";

const InvalidTokenDialog = ({ open, setOpen, errorMessage }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: 3,
          padding: 2,
          backgroundColor: "#fdfdfd",
          minWidth: "400px",
        },
      }}
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "#d32f2f",
        }}
      >
        <Box display="flex" alignItems="center">
          <ErrorOutlineIcon sx={{ fontSize: 32, marginRight: 1 }} />
          <Typography variant="h6">Invalid Link</Typography>
        </Box>
        <IconButton onClick={handleClose} sx={{ color: "#d32f2f" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ color: "#888" }}>
          Please contact your administrator to resolve this issue.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          variant="contained"
          sx={{
            backgroundColor: colors.secondary,
            color: "#fff",
            "&:hover": {
              backgroundColor: colors.primaryHover,
            },
            textTransform: "none",
            padding: "8px 16px",
            borderRadius: 2,
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InvalidTokenDialog;
